// extracted by mini-css-extract-plugin
export var waveHeaderContainer = "hero-module--wave-header-container--3JZ5T";
export var headerTextBackdrop = "hero-module--header-text-backdrop--29bJt";
export var headerTextContainer = "hero-module--header-text-container--Fc5ch";
export var titleSmall = "hero-module--title-small--h_sty";
export var hero = "hero-module--hero--25w3J";
export var meta = "hero-module--meta--2VnQH";